import { createSlice } from '@reduxjs/toolkit';

const breadcrumbsSlice = createSlice({
  name: 'breadcrumbs',
  initialState: { path: [], showMenu: false },
  reducers: {
    setBreadcrumbs(state, action) {
      return {
        ...state,
        path: action.payload,
      };
    },
    showMenu(state, action) {
      return { ...state, showMenu: action.payload };
    },
  },
});

export const breadcrumbsActions = breadcrumbsSlice.actions;
export default breadcrumbsSlice.reducer;
